import * as types from './mutations-types'

export const abrirChat = (context, usuario) => {
  context.commit(types.setChatUser, usuario)
  context.commit(types.setChatOpened, true)
}

export const fecharChat = (context) => {
  context.commit(types.setChatOpened, false)
}



// WEBPACK FOOTER //
// ./src/domain/chat/store/actions.js